export default __webpack_public_path__ + "static/media/service-thumb-stone-masonry.62adb6a1.jpg";